import PropTypes from 'prop-types';
import React from 'react';
import useDateFilterDisplayValue from '../../utils/useDateFilterDisplayValue';
import FilterString from '../../FilterString';
import { date as dateFormatter } from '../../../DataGrid/formatters';

const DateRenderer = ({ name, operator, renderSettings, value }) => {
  const [displayValue, displayOperator] = useDateFilterDisplayValue({
    operator,
    value,
    formatter: dateFormatter,
  });

  return (
    <FilterString
      name={name}
      operator={displayOperator}
      value={displayValue}
      renderSettings={renderSettings}
    />
  );
};

DateRenderer.propTypes = {
  name: PropTypes.string,
  operator: PropTypes.string,
  renderSettings: PropTypes.object,
  value: PropTypes.array,
};

DateRenderer.defaultProps = {
  name: '',
  operator: '',
  renderSettings: {},
  value: [],
};

export default DateRenderer;
